import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-background-50 pt-16 md:pt-20">
      <div className="text-center px-4">
        <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-6">
          <i className="ri-error-warning-line w-12 h-12 flex items-center justify-center text-4xl"></i>
        </div>
        <h1 className="font-heading font-bold text-5xl md:text-7xl text-foreground-900 mb-2">404</h1>
        <p className="text-lg md:text-xl text-foreground-600 mb-6">Page not found</p>
        <p className="text-sm text-foreground-500 max-w-md mx-auto mb-8">
          The page you are looking for might have been moved, deleted, or does not exist. Let us get you back on track.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-all whitespace-nowrap"
        >
          <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}